export const tutorialGame = {
    gameid: 433029, 
    maxUsers: 12, 
    prizeValue: 2, 
    filled: false, 
    fillStatusUsers: 11, 
    userEntered: false, 
    id: 433029
}